export default __webpack_public_path__ + "static/media/img13.77df87cf.png";